// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__2uIDC","overflow":"header_overflow__3Idc7","logo":"header_logo__3iv0M"};